// Module
var code = "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M21 18.429A2.57 2.57 0 0118.429 21H4.286a1.286 1.286 0 010-2.571h13.821a.321.321 0 00.322-.322V4.286a1.286 1.286 0 112.571 0v14.143z\" fill=\"currentColor\"/></svg>";
// Exports
module.exports = code;